import dynamic from "next/dynamic"
import { Culture } from "utils"

const defaultComponents = {}

const BlockRenderer = ({
  blockType,
  blockData,
  components,
  children,
  culture,
  locale,
  props,
}: {
  blockType: string
  blockData: any
  components: any
  children?: any
  props?: any
  locale?: string
  culture?: Culture
}) => {
  const effectiveComponents = { ...defaultComponents, ...components }
  if (!effectiveComponents[blockType]) {
    return <div>No Component Found</div> // TODO: remove when production
  }
  const ComponentToRender = dynamic(effectiveComponents[blockType])

  return (
    <ComponentToRender
      data={blockData}
      locale={locale}
      culture={culture}
      {...props}
    >
      {children}
    </ComponentToRender>
  )
}

export default BlockRenderer
